import React, { useEffect } from 'react'
import PageLayout from 'layouts/PageLayout'
import Footer from 'components/Footer'
import styled from 'styled-components'
import Spinner from 'components/Spinner'
import Heading from 'components/Heading'
import { useQueryParams } from 'utils'
import {
  sourceToSsoSignInSource,
  useGetSsoStartUrl,
} from 'modules/sso/operations'
import { useToast } from 'containers/ToastManager'

const LoadingStateContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  justify-content: center;
  flex-grow: 1;
  align-self: center;

  margin: 16px 0;
`

const StyledSpinner = styled(Spinner)`
  display: flex;
  align-self: center;
`

const Message = styled(Heading.H2)`
  margin: 32px auto;
`

export const RedirectingToIdentityProvider = () => {
  const { showToast } = useToast()
  const { source = 'sketch', team } = useQueryParams<'SSO_SIGN_IN'>()

  const { getUrl, response } = useGetSsoStartUrl({
    source: sourceToSsoSignInSource[source] ?? 'sketch',
    onNetworkError: error => showToast(error, 'negative'),
  })

  useEffect(() => {
    getUrl({ teamName: team! })
  }, [getUrl, team])

  if (response.url) {
    window.location.href = response.url
  }

  return (
    <PageLayout showHeader={false} footer={<Footer />}>
      <LoadingStateContainer>
        <StyledSpinner size="40px" primary />
        <Message>Redirecting to Identity Provider&hellip;</Message>
      </LoadingStateContainer>
    </PageLayout>
  )
}
